export default "__VITE_ASSET__DQuEGphc__"